import React, { useState } from 'react'
import { getInvestor } from '../../api/contactus'
import { useQuery } from '@tanstack/react-query'
import { FiLoader } from 'react-icons/fi'
import Pagination from '../../components/Pagination'

const Investor = () => {
  const [page, setPage] = useState('1')

  const { isPending, isError, error, data } = useQuery({
    queryKey: ['investor', page],
    queryFn: () => getInvestor(page),
  })

  // console.log('investor', data)

  // const totalPages = data.totalCount || 5

  // 🔹 Loading State
  if (isPending) {
    return (
      <div className="flex justify-center items-center h-80">
        <FiLoader className="w-8 h-8 animate-spin text-orange-500" />
        <span className="ml-3 text-gray-600 text-lg font-medium">
          Loading investors...
        </span>
      </div>
    )
  }

  // 🔹 Error State
  if (isError) {
    return (
      <div className="text-center text-red-600 mt-20">
        <p className="text-lg font-semibold">Failed to load data 😞</p>
        <p className="text-gray-500">{error?.message}</p>
      </div>
    )
  }

  return (
    <div>
      Investor
      {/* <div className="mt-8 flex justify-center">
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
      </div> */}
    </div>
  )
}

export default Investor
